import { render, staticRenderFns } from "./kalemrehber.vue?vue&type=template&id=59afdd89"
import script from "./kalemrehber.vue?vue&type=script&lang=js"
export * from "./kalemrehber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports